// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"27741825","966":"ecdfd895"}[chunkId] + ".chunk.js";
};